import { NgModule, Type } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { ErrorPageNotFoundComponent } from '@app/features/errors/error-page-not-found/error-page-not-found.component';
import {
  ErrorSubscriptionExpiredComponent
} from '@app/features/errors/error-subscription-expired/error-subscription-expired.component';
import { ErrorUnauthorizedComponent } from '@app/features/errors/error-unauthorized/error-unauthorized.component';
import { ErrorRoutingModule } from '@app/features/errors/error.module';
import { AcceptInvitationComponent } from '@app/features/fullscreens/accept-invitation/accept-invitation.component';
import { RedirectComponent } from '@app/features/fullscreens/redirect/redirect.component';
import {
  UserBiReportsHeaderComponent
} from '@app/features/main/banner/user-bi-reports-header/user-bi-reports-header.component';
import { MainComponent } from '@app/features/main/main.component';
import { OrganizationsComponent } from '@app/features/main/views/organizations/organizations.component';
import {
  UserBiReportsComponent
} from '@app/features/main/views/organizations/user-bi-reports/user-bi-reports.component';
import authenticationGuard from '@services/guards/authentication.guard';
import authorizationGuard from '@services/guards/authorization.guard';
import cleanupGuard from '@services/guards/cleanup.guard';
import isTbGuard from '@services/guards/is-tb.guard';
import organizationGuard from '@services/guards/organization.guard';

export interface RouteData {
  headerComponent?: Type<any>;
  title?: string;
  // Close the sidenav, user can't interact with it
  hideSidenav?: boolean;
  hideHeader?: boolean;
  // Hide breadcrumb
  hideBreadcrumb?: boolean;
  // Close the sidenav on the page, but it is still openable
  closeSidenav?: boolean;
  permissions?: PermissionEnum[];
}

export const routes: Routes = [
  {
    path: '',
    canActivate: [authenticationGuard],
    component: RedirectComponent,
    pathMatch: 'full'
  },
  {
    path: 'join',
    component: AcceptInvitationComponent
  },
  {
    path: '',
    canActivate: [authenticationGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        canActivate: [isTbGuard],
        loadChildren: (): Promise<any> => import('./features/main/views/_tb/tb.module').then(module => module.TbModule)
      },
      {
        path: 'organizations',
        component: OrganizationsComponent,
        data: <RouteData>{
          title: 'TITLE.ORGANIZATIONS',
          hideHeader: true,
          hideSidenav: true
        }
      },
      {
        path: 'report/:id',
        canActivate: [authorizationGuard],
        component: UserBiReportsComponent,
        data: <RouteData>{
          permissions: [PermissionEnum.VIEW_BI_REPORT],
          headerComponent: UserBiReportsHeaderComponent,
          hideSidenav: true
        }
      },
      {
        path: 'organization/:oid',
        data: <RouteData>{
          breadCrumb: 'TITLE.HOME'
        },
        canActivate: [organizationGuard],
        canDeactivate: [cleanupGuard],
        loadChildren: (): Promise<any> => import('./features/main/views/management/management.module').then(module => module.ManagementModule)
      }
    ]
  },
  // Authentication error
  {
    path: 'unauthorized',
    component: ErrorUnauthorizedComponent
  },
  // Subscription expired
  {
    path: 'expired',
    component: ErrorSubscriptionExpiredComponent
  },
  // Fallback to Page not found error
  {
    path: '**',
    component: ErrorPageNotFoundComponent
  }
];

@NgModule({
  imports: [
    ErrorRoutingModule,
    RouterModule.forRoot(routes, {
      enableTracing: false,
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
